import { cx } from 'cva';

import { Icon, type IconProps } from '../icon/icon';

import styles from './empty_state.module.css';

export type EmptyStateIconProps = IconProps;

/**
 * EmptyStateIcon - icon sub-component for empty states.
 */
export function EmptyStateIcon({
  className,
  name,
  ...rest
}: EmptyStateIconProps) {
  return (
    <div className={styles.icon_wrapper}>
      <Icon
        className={cx([styles.icon, className])}
        size="l"
        name={name}
        {...rest}
      />
    </div>
  );
}
